import { FC, ReactNode } from "react";
import { Nav } from "react-bootstrap";
import styled from "styled-components";
import type { UrlObject } from "url";

export const NavIcon = styled.i`
  color: var(--aa-yellow);
  padding-right: 10px;
`;

const NavItemStyled = styled(Nav.Item)<{ $active: boolean }>`
  ${({ $active }) =>
    $active
      ? `background-color: rgb(var(--aa-active-nav-rgb), var(--aa-active-nav-opacity))`
      : ``}
`;

const NavSectionTitleStyled = styled(Nav.Item)`
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  color: var(--aa-beige);
  user-select: none;
  font-size: 0.8em;
  opacity: 0.6;
  text-transform: uppercase;
  max-width: 220px;
`;

const NavSectionTitle = ({ children }: { children: ReactNode }) => (
  <NavSectionTitleStyled>{children}</NavSectionTitleStyled>
);

export enum NavItemType {
  LINK = "link",
  SECTION_TITLE = "section_title",
}

export type NavLinkType = {
  type: NavItemType.LINK;
  iconClassName: string;
  href: string;
  label: ReactNode;
  isRootPath?: boolean;
};

export type NavSectionTitleType = {
  type: NavItemType.SECTION_TITLE;
  label: string;
};

export type NavItem = NavLinkType | NavSectionTitleType;

export type LinkComponentType = FC<{
  children: ReactNode;
  href: string | UrlObject;
  className?: string | undefined;
  replace?: boolean;
}>;

function Sidebar({
  config,
  LinkComponent,
  getIsActive,
}: {
  config: NavItem[];
  LinkComponent: LinkComponentType;
  getIsActive: (navItem: NavItem) => boolean;
}) {
  return (
    <div className="bg-secondary" style={{ minWidth: "220px" }}>
      <Nav className="flex-column">
        {config.map((navItem) => {
          const { type, label } = navItem;
          if (type === NavItemType.LINK) {
            const { href, iconClassName, label } = navItem;
            const isActive = getIsActive(navItem);
            return (
              <NavItemStyled key={href} $active={isActive}>
                <LinkComponent
                  href={href}
                  className="nav-link"
                  replace={isActive}
                >
                  <NavIcon className={iconClassName} />
                  {label}
                </LinkComponent>
              </NavItemStyled>
            );
          } else if (type === NavItemType.SECTION_TITLE) {
            return <NavSectionTitle key={label}>{label}</NavSectionTitle>;
          }
        })}
      </Nav>
    </div>
  );
}

export default Sidebar;
